import { appConstants } from "../utils";

const refreshToken = async () => {
  const accessToken = localStorage.getItem(appConstants.IQ_HUB_TOKEN_NAME);
  const response = await fetch(`${appConstants.IQ_HUB_API_URL}/refreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      [appConstants.IQ_HUB_TOKEN_NAME]: accessToken,
    },
    credentials: "include",
  });
  if (response.status !== 200) {
    // removing local storage here, so the defined event handler won't trigger logout API
    localStorage.removeItem(appConstants.IQ_HUB_TOKEN_NAME);
    window.dispatchEvent(new CustomEvent("IQ_LOGIN_REQUIRED"));
    return;
  }

  const { token } = await response.json();
  return token;
};

export const customizedFetch = async (...args) => {
  let [url, urlObject = { method: "GET" }] = args;
  const accessToken = localStorage.getItem(appConstants.IQ_HUB_TOKEN_NAME);
  if (accessToken) {
    urlObject = {
      ...urlObject,
      headers: {
        ...(urlObject?.headers ?? {}),
        [appConstants.IQ_HUB_TOKEN_NAME]: accessToken,
      },
    };
  }
  const response = await fetch(url, urlObject);
  if (response.status === 440) {
    const token = await refreshToken();
    if (token) {
      localStorage.setItem(appConstants.IQ_HUB_TOKEN_NAME, token);
      urlObject = {
        ...urlObject,
        headers: {
          ...(urlObject?.headers ?? {}),
          [appConstants.IQ_HUB_TOKEN_NAME]: token,
        },
      };
      const response = await fetch(url, urlObject);
      return response;
    }
  } else {
    return response;
  }
};
